import React from 'react';
import { Link } from 'react-router-dom';
import { CONTACT_INFO, FOOTER_LINKS, SOCIAL_LINKS, APP_TAGLINE } from '../../utils/constants';

const Footer = () => {
  return (
    <footer className="bg-peacock-blue text-warm-cream shadow-peacock">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand Information */}
          <div className="space-y-4">
            <h3 className="text-2xl font-display text-warm-cream">MoreByPrinal</h3>
            <p className="text-sm font-serif text-warm-cream italic">
              {APP_TAGLINE}
            </p>
            <p className="text-sm text-warm-cream leading-relaxed">
              Born from love and friendship, MoreByPrinal reimagines Indian wear with care and intention. 
              We create clothing that feels personal, rooted, and quietly beautiful - designed with love, 
              crafted for you.
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="text-lg font-serif font-semibold text-warm-cream">Quick Links</h4>
            <div className="grid grid-cols-2 gap-2">
              {FOOTER_LINKS.quickLinks.map((link) => (
                <Link
                  key={link.name}
                  to={link.path}
                  className="text-sm text-warm-cream hover:text-peacock-gold transition-colors duration-200"
                >
                  {link.name}
                </Link>
              ))}
            </div>
          </div>

          {/* Contact Us */}
          <div className="space-y-4">
            <h4 className="text-lg font-serif font-semibold text-warm-cream">Contact Us</h4>
            <div className="space-y-2">
              <p className="text-sm text-warm-cream">
                <span className="font-medium">PHONE:</span> {CONTACT_INFO.phone}
              </p>
              <p className="text-sm text-warm-cream">
                <span className="font-medium">EMAIL:</span> {CONTACT_INFO.email}
              </p>
            </div>
            
            {/* Social Media Icons */}
            <div className="flex space-x-3 pt-2">
              <a
                href={SOCIAL_LINKS.instagram}
                target="_blank"
                rel="noopener noreferrer"
                  className="w-8 h-8 bg-peacock-teal rounded-full flex items-center justify-center hover:scale-110 transition-transform duration-200 shadow-elegant"
                >
                  <svg className="w-4 h-4 text-warm-cream" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>
              <a
                href={SOCIAL_LINKS.facebook}
                target="_blank"
                rel="noopener noreferrer"
                  className="w-8 h-8 bg-peacock-teal rounded-full flex items-center justify-center hover:scale-110 transition-transform duration-200 shadow-elegant"
                >
                  <svg className="w-4 h-4 text-warm-cream" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Copyright */}
        <div className="border-t border-warm-cream mt-8 pt-6">
          <div className="text-center text-sm text-warm-cream">
            <p>© 2025 MoreByPrinal. All rights reserved.</p>
            <p className="mt-1">
              Made with <span className="text-peacock-gold">❤️</span> by{' '}
              <a 
                href="https://www.linkedin.com/in/hiral-kotwani/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-warm-cream hover:text-peacock-gold transition-colors duration-200"
              >
                Hiral Kotwani
              </a>{' '}
              and{' '}
              <a 
                href="https://www.linkedin.com/in/lavesh-paryani/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-warm-cream hover:text-peacock-gold transition-colors duration-200"
              >
                Lavesh Paryani
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
